import { Button } from "@shapr3d/frontend-lib";

import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";

import style from "./AccountDeletionSuccess.module.css";

interface AccountDeletionSuccessProps {
  onBackButton: () => void;
}

const AccountDeletionSuccess = ({ onBackButton }: AccountDeletionSuccessProps) => {
  const { t, m } = useTranslation();

  return (
    <div className={style.container}>
      <div className={style.accountDeletionSuccessContent}>
        <Heading type="h1">{t(m.Account.AccountDeleted)}</Heading>

        <div className={style.paragraph}>{t(m.Account.AccountDeletedDescription)}</div>

        <Button variant="grayscale" className={style.backButton} onClick={onBackButton}>
          {t(m.Account.BackToHomepage)}
        </Button>
      </div>
    </div>
  );
};

export default AccountDeletionSuccess;
